import { Button } from '@chakra-ui/react';
import { ColunaGrid, OktonDataGridColumn, Ordenacao } from '@okton/platform-ui';
import { ArrowDown, ArrowUp, ChevronsUpDown } from 'lucide-react';
import React from 'react';

type Celulas<T> = Partial<Record<string, (item: T) => React.ReactNode>>;

/**
 * Converte as colunas do useGrid nas do OktonDataGrid, com o mesmo cabeçalho
 * de ordenação do OktonSimpleCrudList da lib (o OktonDataGrid não ordena
 * sozinho). Coluna sem `valor` não ordena. `celulas` troca o conteúdo de uma
 * coluna; sem ela, a célula mostra o `valor` ou "—".
 */
export function colunasDataGrid<T>(
  colunas: ColunaGrid<T>[],
  ordenacao: Ordenacao | null,
  alternarOrdenacao: (chave: string) => void,
  celulas: Celulas<T> = {},
): OktonDataGridColumn<T>[] {
  return colunas.map(coluna => {
    const ativa = ordenacao?.chave === coluna.chave;
    const icone = !ativa ? (
      <ChevronsUpDown size={13} />
    ) : ordenacao?.desc ? (
      <ArrowDown size={13} />
    ) : (
      <ArrowUp size={13} />
    );

    return {
      key: coluna.chave,
      header: coluna.valor ? (
        <Button
          variant="ghost"
          size="xs"
          px="0"
          h="auto"
          fontWeight="medium"
          rightIcon={icone}
          onClick={() => alternarOrdenacao(coluna.chave)}
        >
          {coluna.titulo}
        </Button>
      ) : (
        coluna.titulo
      ),
      width: coluna.largura,
      align: coluna.alinhamento,
      render:
        celulas[coluna.chave] ??
        (item => {
          const valor = coluna.valor?.(item);
          return valor === null || valor === undefined || valor === ''
            ? '—'
            : valor;
        }),
    };
  });
}
